import polylot from './polyglot';

export default polylot;
